import { useMemo } from "react";

const CharacterCounter = ({value, maxLength}) => {
  const left = useMemo(() => (Number(maxLength) || 0) - (Number(value?.length) || 0), [value, maxLength]);
  return (
    <span style={{ color: left < 0 ? "#cc0000" : "inherit" }}>{value?.length}/{maxLength} characters</span>
  )
}

export default CharacterCounter;